import type { Ref } from 'vue'

type Input = {
  serverOptions: Ref
}

export const makeRequestParams = ({ serverOptions }: Input) => ({
  type: 'staff',
  limit: serverOptions.value.rowsPerPage || 25,
  page: serverOptions.value.page || 1,
})
